var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.684 2.4a1.2 1.2 0 0 0-.998.534l-.975 1.463A3.6 3.6 0 0 1 4.716 6H3.6a1.2 1.2 0 0 0-1.2 1.2V18a1.2 1.2 0 0 0 1.2 1.2h16.8a1.2 1.2 0 0 0 1.2-1.2V7.2A1.2 1.2 0 0 0 20.4 6h-1.116a3.6 3.6 0 0 1-2.995-1.603l-.975-1.463a1.2 1.2 0 0 0-.998-.534zM6.69 1.603A3.6 3.6 0 0 1 9.684 0h4.632a3.6 3.6 0 0 1 2.995 1.603l.975 1.463a1.2 1.2 0 0 0 .998.534H20.4A3.6 3.6 0 0 1 24 7.2V18a3.6 3.6 0 0 1-3.6 3.6H3.6A3.6 3.6 0 0 1 0 18V7.2a3.6 3.6 0 0 1 3.6-3.6h1.116c.4 0 .775-.2.998-.534zM12 9.6a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8M7.2 12a4.8 4.8 0 1 1 9.6 0 4.8 4.8 0 0 1-9.6 0",
    clipRule: "evenodd"
  })));
};
export default SvgCamera;